import client from './client';
import qs from 'qs';

/**
 * 소재검수 일반소재 리스트
 */
export const normalList = (params) =>
  client.get(`/api/manage/matter/normal`, params);

/**
 * 소재검수 이미지 리스트
 */
export const normalImages = (params) =>
  client.get(`/api/manage/matter/image`, { params: params });

/**
 * 소재검수 상태변경
 */
export const changeState = (params) =>
  client.post(`/api/manage/matter/state`, qs.stringify(params));

/**
 * 소재검수 카피 리스트
 */
export const copyList = (params) =>
  client.get(`/api/manage/matter/copy`, params);

/**
 * 소재검수 상태 전광판
 */
export const statusList = (params) =>
  client.get(`/api/manage/matter/status`, params);
